module.exports = "pegasus/assets/blocks/column-8-tech.png";